import { render, staticRenderFns } from "./Babylon.vue?vue&type=template&id=20dae282&scoped=true&"
import script from "./Babylon.vue?vue&type=script&lang=js&"
export * from "./Babylon.vue?vue&type=script&lang=js&"
import style0 from "./Babylon.vue?vue&type=style&index=0&id=20dae282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dae282",
  null
  
)

export default component.exports